import React, { ReactElement } from 'react';
import { Translate } from 'react-redux-i18n';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Button from '../../common/Button';

type Props = RouteComponentProps & {
  title: string,
  goTo: string,
  label: string,
  img: string,
};

function ChooseProfileButton(props: Props): ReactElement {
  return (
    <div className="choose-profile-button">
      <h4>
        <div className="title-background primary" />
        <Translate value={props.title} />
      </h4>
      <img src={props.img} alt={props.title} />
      <Button
        type="primary"
        buttonType="button"
        onClick={() => props.history.push(props.goTo)}
      >
        <Translate value={props.label} />
      </Button>
    </div>
  );
}

export default withRouter(ChooseProfileButton);
